import getConfig from 'next/config';
import logger from './logger';

const {
  publicRuntimeConfig: { runtimeEnv },
} = getConfig();

export const filterLogs = () => {
  // Prevents misclassification of external logs in the log management tool (e.g. Loki)
  if (typeof window === 'undefined' && runtimeEnv !== 'dev') {
    console.warn = function (...message) {
      logger.warn(message.join(' '));
    };

    console.error = function (...message) {
      logger.error(message.join(' '));
    };

    console.log = function (...message) {
      logger.log(message.join(' '));
    };
  }

  const defaultError = console.error;
  const defaultWarn = console.warn;

  console.error = function filterErrors(...parameters: any) {
    const supressedErrors = [
      'Invalid prop `progressBar`',
      'useLayoutEffect does nothing on the server',
      'Warning: Prop `%s` did not match. Server',
    ];

    const filter = parameters.some((parameter: any) => {
      if (typeof parameter === 'string') {
        return supressedErrors.some((entry) => parameter.includes(entry));
      }
      if (parameter instanceof Error) {
        return supressedErrors.some((entry) =>
          parameter.message.includes(entry),
        );
      }

      return false;
    });

    if (!filter) {
      defaultError.apply(console, parameters);
    }
  };

  console.warn = function filterWarnings(...parameters: any) {
    const supressedWarnings = [
      'Rheostat', // https://github.com/airbnb/rheostat/issues/248
    ];

    const filter = parameters.some((parameter: any) => {
      if (typeof parameter === 'string') {
        return supressedWarnings.some((entry) => parameter.includes(entry));
      }
      if (parameter instanceof Error) {
        return supressedWarnings.some((entry) =>
          parameter.message.includes(entry),
        );
      }

      return false;
    });

    if (!filter) {
      defaultWarn.apply(console, parameters);
    }
  };
};
